// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"4d2fdefe","611":"f0a93acc","754":"f1a98d0e"}[chunkId] + ".chunk.js";
};